export interface Tq6SecaM {
  capacity: string;
  umpumpable: string;
  lsfoservicetank: string;
  minimalfeasble: string;
}

export const tq6SecaFormInit = {
  capacity: "",
  umpumpable: "",
  lsfoservicetank: "",
  minimalfeasble: "",
};

export function mapSqlToTq6SecaForm(_seca: any): Tq6SecaM {
  return {
    capacity: _seca.CAPACITY,
    umpumpable: _seca.UNPUMPABLE,
    lsfoservicetank: _seca.LSFO_SERVICE_TANK,
    minimalfeasble: _seca.MINIMAL_FEASBLE,
  };
}
